import { FC, useState } from 'react';
import { Search } from '@silverfort/sf-components';

export interface UsersTableSearchProps {
    onSearchChange: (search: string) => void;
    search: string;
}

const LocalAccountsSearch: FC<UsersTableSearchProps> = ({ onSearchChange, search }) => {
    const handleChange = (search: string) => {
        onSearchChange(search);
    };

    return (
        <Search
            border
            text={search}
            placeholder="Search user"
            onChange={handleChange}
            className="w-[calc((100%-36px)/4)] focus-within:bg-sf-gray-50"
        />
    );
};

export default LocalAccountsSearch;
